import DOMPurify from "dompurify";
import { marked } from "marked";
import TurndownService from "turndown";

const turndown = new TurndownService({
  headingStyle: "atx",
  codeBlockStyle: "fenced",
  emDelimiter: "_",
  bulletListMarker: "-",
});

turndown.addRule("strikethrough", {
  filter: ["del", "s"],
  replacement(content) {
    return `~~${content}~~`;
  },
});

export function markdownToHtml(markdown: string): string {
  const rawHtml = marked.parse(markdown, {
    gfm: true,
    breaks: false,
  });
  return DOMPurify.sanitize(String(rawHtml));
}

export function htmlToMarkdown(html: string): string {
  const clean = DOMPurify.sanitize(html);
  return turndown.turndown(clean).trimEnd() + "\n";
}

export function buildStats(markdown: string): { words: number; chars: number } {
  const trimmed = markdown.trim();
  const words = trimmed.length === 0 ? 0 : trimmed.split(/\s+/).length;
  return { words, chars: markdown.length };
}
